import { render, staticRenderFns } from "./Seaway.vue?vue&type=template&id=1f1c52be&"
import script from "./Seaway.vue?vue&type=script&lang=js&"
export * from "./Seaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports